/* https://codepen.io/sat-ui/pen/BeWbeo */
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-loaders-error',
    templateUrl: './loaders-error.shared.component.html',
    styleUrls: ['./loaders-error.shared.component.scss']
})
export class LoadersErrorComponent implements OnInit {
    @Input() public inverted: boolean = false;
    constructor() { }

    ngOnInit(): void { }
}
